<template>
  <div v-frag>
    <CardIeaAppMain>
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <CardIeaApp colorCard="#A7BA38" title="Olvidé mi contraseña">
          <v-form ref="form" v-model="valid" lazy-validation @submit="login()">
            <v-row align="center">
              <v-col cols="12" sm="12" xs="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[0]" />
              </v-col>
            </v-row>
          </v-form>
        </CardIeaApp>
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
        <v-btn
          @click="olvidoPass()"
          block
          x-large
          class="white--text rounded-lg font-weight-regular"
          depressed
          color="btnSuccess"
          :disabled="!valid"
          >Recuperar contraseña</v-btn
        >
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
        <v-btn
          @click="login()"
          block
          x-large
          class="grey--text text-decoration-underline font-weight-regular"
          depressed
          text
          color="#FFFFFF"
          :disabled="!valid"
          >Ingresar</v-btn
        >
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
        <v-btn
          @click="olvidoUser()"
          block
          x-large
          class="grey--text text-decoration-underline font-weight-regular"
          depressed
          text
          color="#FFFFFF"
          :disabled="!valid"
          >Olvíde mi usuario</v-btn
        >
      </v-col>
      <br /><br /><br /><br /><br />
      <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6"></v-col>
    </CardIeaAppMain>
  </div>
</template>

<script>
// @ is an alias to /src
import CardIeaApp from "../components/CardIeaApp";
import CardIeaAppMain from "../components/CardIeaAppMain";
import InputCustom from "../components/InputCustom";
import MessagesRules from "../config/MessagesRules";
export default {
  name: "Login",
  components: {
    CardIeaApp,
    InputCustom,
    CardIeaAppMain
  },
  // computed: {
  //   loader() {
  //     return this.$store.getters.loader;
  //   }
  // },
  data: () => ({
    valid: true,
    inputs: [
      {
        tag: "DNI",
        text: "DNI",
        placeholder: "",
        icon: "mdi-account",
        required: true,
        value: "",
        type: "text",
        rules: [v => !!v || "DNI" + MessagesRules.required],
        counter: 0
      },
      {
        tag: "password",
        text: "Contraseña",
        placeholder: "",
        icon: "mdi-lock",
        required: true,
        value: "",
        type: "password",
        rules: [v => !!v || "Contraseña" + MessagesRules.required],
        counter: 0
      }
    ]
  }),
  methods: {
    async olvidoPass() {
      let that = this;
      if (this.$refs.form.validate()) {
        await this.$API
          .post({
            url: "alumno/sendPassword",
            data: that.inputs,
            form: true
          })
          .then(res => {
            console.log(res);
            alert('Tu contraseña fué enviada a tu correo electrónico')
           
          });
      }
    },
    async login() {
      this.$router.replace({ name: "Login" });
    },
    async olvidoUser() {
      this.$router.replace({ name: "RecoverUser" });
    }
  }
};
</script>
